import { render, staticRenderFns } from "./BatchManagementImport.vue?vue&type=template&id=4b2075a7&"
import script from "./BatchManagementImport.vue?vue&type=script&lang=js&"
export * from "./BatchManagementImport.vue?vue&type=script&lang=js&"
import style0 from "./BatchManagementImport.vue?vue&type=style&index=0&id=4b2075a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports